import styled from 'styled-components';


export const TableHead= styled.th
.attrs(() => ({
  className: 'white mt-25',
}))`
color: #18181B;
font-family: Plus Jakarta Sans;
font-size: 13px !important;
font-style: normal;
font-weight: 600 !important;

`;

export const TableBodyRow= styled.tr
.attrs(() => ({
  className: 'white ',
}))`
color: #18181B;
font-family: Plus Jakarta Sans;
font-size: 12px !important;
font-style: normal;
font-weight: 400 !important;
:hover{
  cursor: pointer;
  background: rgba(79, 70, 229, 0.05) !important;
}
`;


